import PropTypes from 'prop-types';
import Header from './Header';
import Footer from '../Footer/BaseFooter';

const SimpleFlexLayout = ({
  children,
  className,
  showFooter,
  showLogin,
  layoutOptions = {}
}) => {
  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <Header
        showLogin={layoutOptions.showLogin ?? showLogin}
        className={className}
      />
      {children}
      <Footer display={layoutOptions.showFooter ?? showFooter} />
    </div>
  );
};

SimpleFlexLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string,
  showFooter: PropTypes.bool,
  showLogin: PropTypes.bool
};

SimpleFlexLayout.defaultProps = {
  className: '',
  showFooter: true,
  showLogin: false
};

export default SimpleFlexLayout;
